<app-registration-form [referralCode]="referralCode" (registrationComplete)="registered($event)"></app-registration-form>
